module.exports = __webpack_public_path__ + "img/logoNew.bfb47edf.png";